// extracted by mini-css-extract-plugin
export var link = "_rb-0";